<template>
  <div>
    <v-dialog v-model="dialog" max-width="80%">
      <v-card>
        <v-toolbar color="secondary" dark>
          <v-toolbar-title> Ajouter une pièce jointe </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap xs12>
              <v-flex xs5>
                <v-combobox
                  class="pt-0"
                  v-model="editedItem.NomDocument"
                  label="Type de pièce"
                  item-text="Lang00"
                  item-value="Id"
                  :title="editedItem.NomDocument"
                  readonly
                >
                </v-combobox>
              </v-flex>
              <v-flex xs6>
                <!--cutom update button AGU-->
                <upload-btn
                  class="mr-10"
                  color="secondary"
                  :loading="uploadFileLoading"
                  :selectedFileName="this.editedItem.NomFichier"
                  defaultButtonText="Sélectionner votre document"
                  ref="btnupload"
                  :acceptFormats="['pdf']"
                  @file-update="selectFile"
                >
                </upload-btn>
                <small
                  >{{ $storeUm6p.Label.Annexes.FormatsAcceptesPdf}}</small
                >
                <br />
                <small>Taille maximum du fichier : 8Mo</small>

                <v-snackbar
                  :timeout="2000"
                  color="error"
                  elevation="24"
                  v-model="snackbar"
                >
                  Taille maximale du fichier dépassée.
                </v-snackbar>
              </v-flex>
              <v-flex xs1> </v-flex>
            </v-layout>
            <v-layout row wrap xs12>
              <span v-if="editedItem.NomFichier">Fichier Sélectionné : </span>
              <span
                v-if="editedItem.NomFichier"
                style="background-color: lightgray"
                >{{ editedItem.NomFichier }}</span
              >
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" dark @click="close">Annuler</v-btn>
          <v-btn color="success" dark :loading="uploadFileLoading" @click="save">Valider</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_msg" max-width="50%">
      <v-alert type="warning">
        {{message}}
      </v-alert>
    </v-dialog>
    <v-alert
      border="left"
      colored-border
      color="secondary"
      elevation="1"
      v-show="$storeDemandeBourse.LienDocumentSalaire"
    >
      Modèle Attestation Salaire Annuel que pour les salariés
      <v-icon
        class="mr-2"
        title="Afficher le document"
        @click="
          $storeCommun.AfficherAnnexe(
            $storeDemandeBourse.LienDocumentSalaire
          )
        "
      >
        {{ icons.mdiFileDownload }}
      </v-icon>
    </v-alert>
    <v-alert
      border="left"
      colored-border
      color="secondary"
      elevation="1"
      v-show="$storeDemandeBourse.LienDocumentDgi"
    >
      Modèle Attestation Revenus DGI
      <v-icon
        class="mr-2"
        title="Afficher le document"
        @click="
          $storeCommun.AfficherAnnexe(
            $storeDemandeBourse.LienDocumentDgi
          )
        "
      >
        {{ icons.mdiFileDownload }}
      </v-icon>
    </v-alert>
    <v-data-table
      :headers="headers"
      :items="$storeDemandeBourse.DonneesFormulaire.ListeAnnexesFirsi"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:no-data>
        <v-alert :value="true" color="info" :icon="icons.mdiAlert"
          >La liste est vide</v-alert
        >
      </template>
      <template v-slot:item="{ item }">
        <tr>
          <th class="text-xs-left">
            {{ item.LabelFormulaire }}
          </th>
          <th class="text-xs-left" style="color: red" v-if="!item.NomFichier">
            Fichier manquant
          </th>
          <th class="text-xs-left" v-else>
            {{ item.NomFichier }}
          </th>
          <th>
            {{ item.ObligatoireSoumettre ? "Oui" : "Non" }}
          </th>
          <th
            class="text-xs-left"
            style="color: red"
            v-if="
              item.ConformiteElectronique.Id == 4251 ||
              item.ConformiteElectronique.Id == 4299
            "
          >
            {{ item.ConformiteElectronique.Lang00 }}
          </th>
          <th class="text-xs-left" v-else>
            {{ item.ConformiteElectronique.Lang00 }}
          </th>
          <th>
            {{ item.NonConformeElectronique }}
          </th>
          <th
            v-show="
              $storeDemandeBourse.DonneesFormulaire.EtatDossier.Id ==
                $storeDemandeBourse.DataId.DossierRetenu ||
              $storeDemandeBourse.DonneesFormulaire.EtatDossier.Id ==
                $storeDemandeBourse.DataId.BoursierFirsi ||
              $storeDemandeBourse.DonneesFormulaire.EtatDossier.Id ==
                $storeDemandeBourse.DataId.DossierNonRetenu
            "
          >
            {{ item.ConformitePhysique.Lang00 }}
          </th>
          <th
            v-show="
              $storeDemandeBourse.DonneesFormulaire.EtatDossier.Id ==
                $storeDemandeBourse.DataId.DossierRetenu ||
              $storeDemandeBourse.DonneesFormulaire.EtatDossier.Id ==
                $storeDemandeBourse.DataId.BoursierFirsi ||
              $storeDemandeBourse.DonneesFormulaire.EtatDossier.Id ==
                $storeDemandeBourse.DataId.DossierNonRetenu
            "
          >
            {{ item.NonConformePhysique }}
          </th>
          <th>
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
              :disabled="item.Valide"
              v-show="item.Editable"
            >
              {{ icons.mdiPencil }}
            </v-icon>
            <v-icon
              v-if="item.UrlFichier"
              small
              class="mr-2"
              title="Afficher le document"
              @click="$storeCommun.AfficherAnnexe(item.UrlFichier)"
            >
              {{ icons.mdiEye }}
            </v-icon>
            <v-icon
              small
              @click="deleteItem(item)"
              v-show="item.NomFichier && item.Editable"
              >{{ icons.mdiDelete }}</v-icon
            >
          </th>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {
  mdiPencil,
  mdiEye,
  mdiClose,
  mdiDelete,
  mdiAlert,
  mdiFileDownload,
} from "@mdi/js";
import UploadButton from "@/components/CustomFileUpload";

export default {
  components: {
    "upload-btn": UploadButton,
  },
  data() {
    return {
      // Icon importés depuis mdi/js pour les icones d'édition/suppression
      icons: {
        mdiPencil,
        mdiEye,
        mdiClose,
        mdiDelete,
        mdiFileDownload,
        mdiAlert,
      },
      $storeDemandeBourse: this.$storeDemandeBourse,
      $storeCatalogue: this.$storeCatalogue,
      $storeCommun:this.$storeCommun,
      // Dialog et flag
      dialog: false,
      dialog_msg: false,
      uploadFileLoading: false,
      snackbar: false,
      message: null,

      //Header list
      headers: [
        { text: "Type de pièce", value: "type" },
        { text: "Fichier", value: "fichier" },
        { text: "Obligatoire", value: "obligatoire" },
        {
          text: "Conformité électronique",
          value: "conformiteelectronique",
          sortable: false,
        },
        { text: "Notes", value: "noteconformiteelectronique", sortable: false },
        {
          text: "Conformité physique",
          value: "conformitephysique",
          sortable: false,
        },
        { text: "Note", value: "noteconformitephysique", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],

      editedIndex: -1,
      editedItem: {
        Supprimer: false,
        IdCrypte: null,
        AnneeScolaire: {
          Id: null,
          Lang00: null,
        },
        ConformiteElectronique: {
          Id: null,
          Lang00: null,
        },
        ConformitePhysique: {
          Id: null,
          Lang00: null,
        },
        NatureDocument: {
          Id: null,
          Lang00: null,
        },
        NomDocument: {
          Id: null,
          Lang00: null,
        },
        NomFichier: null,
        DonneePieceJointe: null,
        NonConformeElectronique: null,
        NonConformePhysique: null,
        CandidatureBourseId: null,
        PpId: null,
        TemplateAnnexeFirsi: null,
        TypeDeDocument: {
          Id: null,
          Lang00: null,
        },
        Fratrie: null,
        SituationFamiliale: null,
        Etape: null,
      },

      pieceManquante: 1,
      index: 0,
    };
  },
  mounted() {
    this.$storeCatalogue.ChargerCataloguesAnnexes();
    if (
      this.$storeDemandeBourse.DonneesFormulaire.EtatDossier.Id ==
        this.$storeDemandeBourse.DataId.DossierRetenu ||
      this.$storeDemandeBourse.DonneesFormulaire.EtatDossier.Id ==
        this.$storeDemandeBourse.DataId.BoursierFirsi ||
      this.$storeDemandeBourse.DonneesFormulaire.EtatDossier.Id ==
        this.$storeDemandeBourse.DataId.DossierNonRetenu
    ) {
      this.headers = [
        { text: "Type de pièce", value: "type" },
        { text: "Fichier", value: "fichier" },
        { text: "Obligatoire", value: "obligatoire" },
        {
          text: "Conformité électronique",
          value: "conformiteelectronique",
          sortable: false,
        },
        { text: "Notes", value: "noteconformiteelectronique", sortable: false },
        {
          text: "Conformité physique",
          value: "conformitephysique",
          sortable: false,
        },
        { text: "Note", value: "noteconformitephysique", sortable: false },
        { text: "", value: "actions", sortable: false },
      ];
    } else {
      this.headers = [
        { text: "Type de pièce", value: "type" },
        { text: "Fichier", value: "fichier" },
        { text: "Obligatoire", value: "obligatoire" },
        {
          text: "Conformité électronique",
          value: "conformiteelectronique",
          sortable: false,
        },
        { text: "Notes", value: "noteconformiteelectronique", sortable: false },
        { text: "", value: "actions", sortable: false },
      ];
    }
  },
  methods: {
    editItem(item) {
      if (
        item &&
        item.NomDocument &&
        item.NomDocument.Id ==
          this.$storeCatalogue.DataId.PropositionAdmission &&
        !this.$storeDemandeBourse.DonneesFormulaire.EcoleRetenue
      ) {
        this.message = "Pour ajouter cette annexe, merci de sélectionner une école dans la liste des concours."
        this.dialog_msg = true;
        return;
      }
      if (
        item &&
        item.DossierBourseId &&
        item.NomDocument &&
        (item.NomDocument.Id == this.$storeCatalogue.DataId.AttestationRibMarroc ||  item.NomDocument.Id == this.$storeCatalogue.DataId.AttestationRibFrance) 
        &&
        (this.$storeDossierBourse.Formulaire.Iban == null || this.$storeDossierBourse.Formulaire.BIC == null
         || 
         this.$storeDossierBourse.Formulaire.Iban == '' || this.$storeDossierBourse.Formulaire.BIC == ''
        )
      ) {
        this.message = "Pour ajouter cette annexe, merci de renseigner l'IBAN et le BIC."
        this.dialog_msg = true;
        return;
      }
      
      if (item.CandidatureBourseId
          && item.NomDocument.Id == this.$storeCatalogue.DataId.AttestationRibMarroc
        && this.$storeCommun.InfosCandidature
        && !this.$storeCommun.InfosCandidature.NumCompteMarocain
      )
      {
        this.message = "Pour ajouter cette annexe, merci de renseigner le numéro de compte bancaire marocain."
        this.dialog_msg = true;
        return;
      }
      

      this.editedIndex =
        this.$storeDemandeBourse.DonneesFormulaire.ListeAnnexesFirsi.indexOf(
          item
        );
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm("Etes-vous sûr de vouloir supprimer ce document ?")) {
        // on récupère l'item depuis le store
        this.editedIndex =
          this.$storeDemandeBourse.DonneesFormulaire.ListeAnnexesFirsi.indexOf(
            item
          );
        // on affecte l'item local pour récupèrer les valeurs
        this.editedItem = Object.assign({}, item);

        var self = this;
        Promise.all([
          // Appel de l'api de suppression de la PJ
          this.$storeDemandeBourse
            .DeleteFichier(
              this.editedItem,
              this.$storeDemandeBourse.DonneesFormulaire.TokenExtranet
            )
            .then((reponse) => {
              if (reponse) {
                this.ParseDtoToEditedItem(reponse.data);
                Object.assign(
                  this.$storeDemandeBourse.DonneesFormulaire.ListeAnnexesFirsi[
                    this.editedIndex
                  ],
                  this.editedItem
                );
              }
            })
            .catch((error) => {
              console.log(error);
            }),
        ]).then(function () {
          // RAZ de editeditem
          self.close();
        });
      }
    },
    // Fonction appelé quand un fichier sélectionné ou déselectionné dans le 'upload-btn'
    async selectFile(file) {
      if (file) {
        if (file.size > 8388608) {
          this.editedItem.NomFichier = "";
          this.editedItem.DonneePieceJointe = null;
          this.snackbar = true;
        } else {
          this.uploadFileLoading = true;
          this.editedItem.NomFichier = file.name;
          await this.readFile(file, this.editedItem);
          setTimeout(this.stopLoadinMode, 2000);
        }
      } else {
        this.editedItem.NomFichier = "";
        this.editedItem.DonneePieceJointe = null;
      }
    },

    // Lire le contenu d'un fichier la data de l'élément en cours
    readFile(file, monFichier) {
      var reader = new FileReader();

      // Listener de fin de lecture
      reader.onloadend = function () {
        monFichier.DonneePieceJointe = btoa(reader.result);
      };

      // Lancer la lecture du fichier

      reader.readAsBinaryString(file);
    },

    // Arrêter
    stopLoadinMode() {
      this.uploadFileLoading = false;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign(
          {},
          {
            Supprimer: false,
            IdCrypte: null,
            AnneeScolaire: {
              Id: null,
              Lang00: null,
            },
            ConformiteElectronique: {
              Id: null,
              Lang00: null,
            },
            ConformitePhysique: {
              Id: null,
              Lang00: null,
            },
            NatureDocument: {
              Id: null,
              Lang00: null,
            },
            NomDocument: {
              Id: null,
              Lang00: null,
            },
            NomFichier: null,
            DonneePieceJointe: null,
            NonConformeElectronique: null,
            NonConformePhysique: null,
            CandidatureBourseId: null,
            PpId: null,
            TemplateAnnexeFirsi: null,
            TypeDeDocument: {
              Id: null,
              Lang00: null,
            },
            Fratrie: null,
            SituationFamiliale: null,
            Etape: null,
          }
        );
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        var self = this;
        this.uploadFileLoading = false;
        this.editedItem.Supprimer = false;
        Promise.all([
          // Sauvegarder le fichier, appelle api
          this.$storeDemandeBourse
            .UploadFichier(
              this.editedItem,
              this.$storeDemandeBourse.DonneesFormulaire.TokenExtranet
            )
            .then((reponse) => {
              if (reponse && reponse.data) {
                this.ParseDtoToEditedItem(reponse.data);
                Object.assign(
                  this.$storeDemandeBourse.DonneesFormulaire.ListeAnnexesFirsi[
                    this.editedIndex
                  ],
                  this.editedItem
                );
              } else {
                console.log("annexe pas enregistrée");
              }
            })
            .catch((error) => {
              console.log("error");
              console.log(error);
            }),
        ]).then(function () {
          self.close();
          self.$refs.btnupload.resetClick();
        });
      }
    },
    ParseDtoToEditedItem(dto) {
      this.editedItem = this.$storeDemandeBourse.elementToAnnexesFirsiDto(dto);
    },
  },
};
</script>
